export const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>,updateNotification) => {
    if (
      !((event.key >= "0" && event.key <= "9") || event.key === "Backspace")
    ) {
      event.preventDefault();
    } else {
      updateNotification("");
    }
  };